import React from "react";
//import getStyled from "../../hooks/getStyled";
import { SFErrorIcon } from "../icons";
import SFTypography from "../typography";
import { SFStack } from "../grid";

//const { styled } = getStyled();

// const StyledWrapper = styled("div")(({ theme }) => ({
//   padding: theme.spacing(2),
//   width: "100%",
//   height: 400,
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
// }));

const SFErrorPlaceholder = ({ message = "Error occured" }) => {
  return (
    <SFStack direction="column" justifyContent="center" alignItems="center" sx={{mt: 2}}>
      <SFErrorIcon size="screenPlaceholder" />
      <SFTypography variant="body1" hasHtml>{message}</SFTypography>
    </SFStack>
  );
};
export default SFErrorPlaceholder;
